import { Injectable, Optional, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { LogService, ServiceRouter, AppDataStore } from '@pershing/pershing-core';
import { PortalComponentServiceDefinition } from './portal-component-service-definition';
import { Observable, BehaviorSubject } from 'rxjs';
import { Params } from '@angular/router';

@Injectable()
export class NxiRestService {
    private serviceUrl: string;
    accountList$: BehaviorSubject<any> = new BehaviorSubject([]);
    accountListObservable$ = this.accountList$.asObservable();
    constructor(private http: HttpClient, private logService: LogService, private serviceRouter: ServiceRouter,
                private appDataStore: AppDataStore, @Optional() @Inject('AppSettings') appSettings: any) {
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(PortalComponentServiceDefinition.getInstance());
        logService.info('NxiRestService : URL', this.serviceUrl);
    } 

 
    public getNxiPreLoginRestResponse(url: string, queryParams: Params): Observable<any> {
        let body = this.convertQueryParamToHttpParams(queryParams);
        return this.http.post(this.serviceUrl + '/prelogin/' + url, body);
    }
    public getAdvisorResponse(url: string): Observable<any> {
        console.log(this.serviceUrl + url);
        return this.http.get(this.serviceUrl + url);
    }


    private convertQueryParamToHttpParams(queryParams: Params): HttpParams {
        let param = new HttpParams();
        if (queryParams === null) {
            return param;
        }
        for (let query in queryParams) {
            if (queryParams.hasOwnProperty(query)) {
                param = param.set(query, queryParams[query]);
            }
        }
        return param;
    }
}
